<template>
  <div class="search-wrap">
    <form
      id="searchform"
      action="/v"
      method="get"
      accept-charset="utf-8"
      @submit="submitEvent"
    >
      <div
        id="searchBox"
        class="search-box"
      >
        <div class="query-box">
          <input
            type="hidden"
            name="w"
            value="06009900"
          >
          <input
            type="hidden"
            name="ie"
            value="utf8"
          >
          <input
            v-if="spver === 1"
            type="hidden"
            name="spver"
            value="1"
          >
          <input
            id="keyword"
            v-model="query"
            type="search"
            class="query"
            placeholder="搜一搜，发现精彩视频"
            name="query"
            autocomplete="off"
            maxlength="100"
            autocorrect="off"
            autocapitalize="off"
            uigs="home_input"
          >
          <span
            v-show="query"
            class="search-del"
            uigs="home_reset"
            @click="resetEvent"
          />
          <div class="search">
            <input
              type="submit"
              value="搜索"
              uigs="home_submit"
            >
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      query: '',
    };
  },
  computed: {
    ...mapState('home', ['spver']),
  },
  methods: {
    submitEvent(e) {
      this.query = this.query.trim();
      if (!this.query) {
        e.preventDefault();
        this.$el.querySelector('#keyword').focus();
      }
    },
    resetEvent() {
      this.query = '';
      this.$el.querySelector('#keyword').focus();
    },
  },
};
</script>

<style lang="scss">
.search-wrap {
  position: relative;
  z-index: 10;

  .search-box {
    height: 52px;
    width: 100%;
  }

  .query-box {
    display: flex;
    position: relative;
    z-index: 3;
    box-sizing: border-box;
    height: 52px;
    border: 2px solid #fff;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.05);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);

    &:focus-within {
      box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.16);
    }

    html[data-theme='dark'] & {
      border-color: rgba(255, 255, 255, 0.5);
    }

    input[type='search'] {
      background-color: transparent;
      -webkit-appearance: none;
      appearance: none;
    }

    input[type='search']::-webkit-search-cancel-button {
      display: none;
    }
  }

  .query {
    flex: 1;
    min-width: 0;
    height: 48px;
    padding: 0 12px 0 17px;
    margin: 0;
    border: 0;
    outline: none;
    font-size: 14px;
    color: #fff;

    html[data-theme='dark'] & {
      color: rgba(255, 255, 255, 0.87);
    }

    &::placeholder {
      color: rgba(255, 255, 255, 0.6);

      html[data-theme='dark'] & {
        color: rgba(255, 255, 255, 0.4);
      }
    }

    &:focus::placeholder {
      opacity: 0;
    }
  }

  .search-del {
    position: relative;
    flex-shrink: 0;
    width: 44px;

    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 16px;
      height: 2px;
      border-radius: 1px;
      background-color: rgba(255, 255, 255, 0.8);
      transform: translate(-50%, -50%) rotate(45deg);

      html[data-theme='dark'] & {
        background-color: rgba(255, 255, 255, 0.5);
      }
    }

    &:after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }

  .search {
    position: relative;
    flex-shrink: 0;
    width: 60px;
    height: 48px;

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      width: 2px;
      height: 23px;
      transform: translateY(-50%);
      background-color: rgba(255, 255, 255, 0.6);

      html[data-theme='dark'] & {
        background-color: rgba(255, 255, 255, 0.3);
      }
    }

    input[type='submit'] {
      display: block;
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      border: 0;
      font-size: 0;
      -webkit-appearance: none;
      appearance: none;
      background: transparent url('~@asset/img/home/search_icon.png') center center no-repeat;
      background-size: 22px 22px;

      html[data-theme='dark'] & {
        opacity: 0.7;
      }
    }
  }
}
</style>
